import { Instagram, Mail, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { LangSwitch } from "./Nav";
import { CONTACT, useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 pt-16">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo testid="footer-logo" />
            <p className="mt-4 font-mono-tc text-xs uppercase tracking-[0.25em] text-zinc-400">{t.footer.tag}</p>
            <div className="mt-6"><LangSwitch testid="footer-language-switch" /></div>
          </div>
          <div className="space-y-3 text-zinc-300">
            <a data-testid="footer-phone-link" href={CONTACT.tel} className="flex items-center gap-3 hover:text-white"><Phone className="h-4 w-4" />{CONTACT.phone}</a>
            <a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-white"><Mail className="h-4 w-4" />{CONTACT.email}</a>
            <a data-testid="footer-instagram-link" href={CONTACT.ig} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-white"><Instagram className="h-4 w-4" />{CONTACT.igHandle}</a>
          </div>
          <div className="space-y-2 font-mono-tc text-xs uppercase tracking-[0.15em] text-zinc-400">
            <p data-testid="footer-nip">NIP: {CONTACT.nip}</p>
            <p>OCP: 350 000 €</p>
            <p>EU License</p>
          </div>
        </div>
      </div>
      <p aria-hidden="true" className="mt-12 select-none text-center font-display text-[24vw] font-black italic leading-[0.75] tracking-tight text-white/[0.06]">TRANSCARS</p>
      <div className="border-t border-white/10">
        <p className="mx-auto max-w-[1400px] px-5 py-6 font-mono-tc text-xs text-zinc-400 sm:px-8">© {new Date().getFullYear()} TRANSCARS · transcars.eu · {t.footer.rights}</p>
      </div>
    </footer>
  );
}
